import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    Box,
    Button,
    IconButton,
    DialogActions,
    Alert,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ImageAuthMissing from '../../assets/zoom_auth.png';
import Helpers from '../helpers/Helpers';
interface ZoomAuthDialogProps {
    open: boolean;
    setOpen: (val: boolean) => void;
    oauthUrl: string;
    token: any;
}

const ZoomAuthDialog: React.FC<ZoomAuthDialogProps> = ({ open, setOpen, oauthUrl,token }) => {
    const handleRetry = () => {
        Helpers.deleteZoomTokens();
        Helpers.revokeZoomToken({ "access_token": token });
        setOpen(false);
        //window.open(
        //    oauthUrl,
        //    "_blank",
        //    "toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=500,width=500,height=600"
        //);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth={false}
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    p: 0,
                },
            }}
        >
            <DialogTitle
                sx={{
                    fontSize: 18,
                    fontWeight: 600,
                    px: 3,
                    pt: 2,
                    pb: 0,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                Authentication Is Required
                <IconButton onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ px: 3, pt: 1 }}>
                <Typography variant="body2" sx={{ mb: 2, color: '#555' }}>
                    Make sure to accept the authentication popup that appears when connecting Zoom.
                </Typography>
                <Box
                    component="img"
                    src={ImageAuthMissing}
                    alt="Zoom Authorization Instruction GIF"
                    sx={{
                        width: 'auto%',
                        maxHeight: 400, // limits the height
                        objectFit: 'contain',
                        borderRadius: 1,
                        border: '1px solid #ccc',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                        display: 'block',
                        margin: '0 auto',
                    }}
                />
            </DialogContent>

            <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: '#00c292',
                        textTransform: 'none',
                        px: 4,
                        '&:hover': {
                            backgroundColor: '#00b386',
                        },
                    }}
                    onClick={handleRetry}
                >
                    Allow Authentication
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ZoomAuthDialog;
